import React from 'react';
import './cssfiles/AboutMe.css';
import myProfileImage from './images/profileimage.jpg';
import CVFile from '../Cvfolder/Johnmary_Udogu_Java_Engineer.pdf'

function AboutMe() {

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = CVFile;
    link.download = 'Johnmary-Udogu-Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="about-me-container">
      <div className="profile-image">
        <img src={myProfileImage} alt="Johnmary Udogu profile" className='aboutimg'/>
      </div>
      <div className="personal-details">
        <h2>About Me</h2>
        <h3>Johnmary Udogu</h3>
        <p className="occupation">
          <span>Java Software Engineer</span>, <span>Full Stack Developer</span>
        </p>
        <p className="residence">
          <strong>Timezone:</strong> GMT+1 (UK/EU overlap)<br />
          <strong>Email:</strong> johnmaryudogu@gmail.com<br />
          <strong>Availability:</strong> Open to Remote Roles<br />
        </p>
        <p className="bio">
          "Java Software Engineer with 3 years of Spring Boot/microservices experience and 5+ years building production apps with React and React Native. I build end-to-end — from designing backend APIs to consuming them on the frontend."
        </p>
        <div className="skills-tags">
          <span>Java</span><span>Spring Boot</span><span>Microservices</span><span>React</span>
          <span>React Native</span><span>PostgreSQL</span><span>Docker</span><span>REST APIs</span>
        </div>
        <button onClick={handleDownload} className="download-cv">
          Download CV <span className="download-icon">⬇️</span>
        </button>
      </div>
    </div>
  );
}

export default AboutMe;